module.exports = {
    digitalPayErrorCodes: {
        // Apigee error codes
        unknown: 'UN99',

        // Container error codes
        creditCardCaptureFormExpired: 'BI10',
        creditCardDeleteLinkedCardForbidden: 'BV37',
        creditCardIframeSucceededPreviously: 'IF06', // Iframe was submitted previously and succeed.
        creditCardIframeUnableToProcessRequest: 'IF98',
        creditCardStepUpTokenRequired: 'BV59',
        giftCardKnownBalanceCheckFailed: 'ES611',
        giftCardNotAcceptedByBanner: 'ES130',
        giftCardUnableToRetrieveDetails: 'ES120',
        giftCardUnknownBalanceCheckFailed: 'ES52',
        giftCardZeroBalance: 'ES56',
        paymentInstrumentExpired: 'ES105',
        paymentInstrumentNotFound: 'BI24',
        paypalAccountLockedOrClosed: 'ES470',
        insufficientFunds: 'ES151',
        unknownPayment: 'ES52',

        // Custom error codes
        giftCardBalanceApiUnavailable: 'DpGiftCardBalanceApiUnavailable',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/digitalpay-errorcodes.js